module.exports = __webpack_public_path__ + "static/media/logoutIconTrans.4f1d6f26.svg";